module.exports = __webpack_public_path__ + "img/1556319156.0728fb30.jpg";